import type { CityConfig } from "../city-template/types";

export const troyMiConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Troy",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "troy-mi",
  route: "/cities/troy-mi",
  title: "Emergency Passport Troy, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Troy, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Troy, Birmingham, Rochester Hills, Bloomfield Hills, and all Oakland County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Troy, MI",
  heroSubtitle: "Troy travelers — from Oakland County executives to Somerset Mall shoppers to Rochester Hills families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the northern Detroit business corridor.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Troy%20Michigan%20downtown%20business%20district%20with%20modern%20office%20buildings%2C%20the%20Somerset%20Collection%20mall%20area%2C%20wide%20tree-lined%20boulevards%2C%20affluent%20suburban%20landscape%20with%20manicured%20greenery%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20Oakland%20County%20suburban%20photography%20without%20text%20or%20people&width=1800&height=700&seq=troy-mi-hero-002&orientation=landscape",
  heroImageAlt: "Troy Michigan downtown business district with modern office buildings and Somerset Collection area",
  geoPosition: "42.6064;-83.1498",
  geoPlacename: "Troy, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 25–30 minutes south of Troy via I-75",
  },
  nearbyCitiesZips: [
    { name: "Troy", zips: "48083, 48084, 48085, 48098, 48099" },
    { name: "Birmingham", zips: "48009, 48012" },
    { name: "Rochester Hills", zips: "48306, 48307, 48309" },
    { name: "Bloomfield Hills", zips: "48301, 48302, 48304" },
    { name: "Clawson", zips: "48017" },
    { name: "Royal Oak", zips: "48067, 48068, 48073" },
    { name: "Madison Heights", zips: "48071" },
    { name: "Berkley", zips: "48072" },
    { name: "Southfield", zips: "48033, 48034, 48075, 48076" },
    { name: "Farmington Hills", zips: "48331, 48333, 48334, 48335, 48336" },
    { name: "Novi", zips: "48374, 48375, 48377" },
    { name: "Pontiac", zips: "48340, 48341, 48342, 48343" },
    { name: "Auburn Hills", zips: "48321, 48326" },
    { name: "Waterford", zips: "48327, 48328, 48329" },
    { name: "Rochester", zips: "48307, 48308" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Detroit Passport Agency — no 25-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Business Corridor Focus", desc: "Serving Oakland County corporate HQ, medical, and professional travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Oakland County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Birmingham, MI", route: "/states/michigan" },
    { name: "Emergency passport help in Rochester Hills, MI", route: "/states/michigan" },
    { name: "Urgent passport services in Detroit, MI", route: "/cities/detroit" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Troy, Michigan remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (25–30 minutes south via I-75) — without you making the drive or dealing with downtown Detroit parking. Troy residents can ship from any UPS or FedEx in Oakland County.",
  fpcOfficeDistance: "Serving Troy, Birmingham, Rochester Hills, Bloomfield Hills, Clawson, Royal Oak, Farmington Hills, Novi, Pontiac, Auburn Hills, and all of Oakland County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Troy and Oakland County. From the Somerset Collection business district to the Rochester Hills residential communities, from the Bloomfield Hills estates to the Auburn Hills auto corridor — we serve all of the northern Detroit business and residential corridor.",
  nearbyCitiesIntro: "We serve Troy and all Oakland County communities including Birmingham, Rochester Hills, Bloomfield Hills, Clawson, Royal Oak, Madison Heights, Berkley, Southfield, Farmington Hills, Novi, Pontiac, Auburn Hills, Waterford, Rochester, and Orion. We also serve western Macomb County communities.",
  howItWorksIntro: "Most Troy travelers complete everything online and ship documents overnight. No need to drive 25–30 minutes to downtown Detroit or find parking at the federal building — our couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Troy is one of the most affluent and internationally connected suburbs in Michigan, with significant corporate headquarters and professional travel demand. Here are the most common passport mistakes we see from Oakland County travelers.",
  testimonialsIntro: "Troy travelers — from Oakland County executives to Rochester Hills families to Bloomfield Hills professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Troy, MI? Here are the most common ones we hear from Oakland County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for Oakland County business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — 25 min drive + parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Troy travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute corporate trips and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Oakland County business and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Troy adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Oakland County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Troy residents and families — including new citizens, students, and Oakland County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Troy residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Troy and Oakland County families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Troy and Oakland County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Troy MI", description: "Urgent passport processing for Troy Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Troy MI", description: "Fast passport renewal for Troy Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Troy MI", description: "New passport application services for Troy Michigan residents applying for their first passport." },
    { name: "Child Passport Troy MI", description: "Minor passport services for Troy Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Troy, MI",
      rating: 5,
      text: "Corporate retreat to Costa Rica in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 36 hours. I shipped from the UPS Store on Big Beaver and never had to drive to Detroit. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David M.",
      location: "Birmingham, MI",
      rating: 5,
      text: "Family vacation to Italy with 10 days notice. Four passports for our whole family. Done in 5 days. The online process was simple and our agent was incredibly responsive. We shipped from FedEx on Woodward.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rachel K.",
      location: "Rochester Hills, MI",
      rating: 5,
      text: "Study abroad semester in London and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. The process was completely hands-off from my end.",
      service: "Passport Renewal",
    },
    {
      name: "Ahmed H.",
      location: "Troy, MI",
      rating: 5,
      text: "Business trip to Dubai with 3 days notice. Fast Passport Center had my emergency passport ready in 24 hours. Their courier literally walked into the Detroit agency while I was in meetings. Phenomenal service.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "troy-1",
      name: "Troy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2840 W Maple Rd",
      city: "Troy",
      state: "MI",
      zip: "48084",
      phone: "(248) 649-5300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Troy, near Somerset Collection",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Troy acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Somerset Collection and the Big Beaver business corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-2",
      name: "Birmingham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 E Merrill St",
      city: "Birmingham",
      state: "MI",
      zip: "48009",
      phone: "(248) 644-0340",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Birmingham, approximately 4 miles south of Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Birmingham, Bloomfield Hills, and southern Oakland County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-3",
      name: "Rochester Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1600 E Auburn Rd",
      city: "Rochester Hills",
      state: "MI",
      zip: "48307",
      phone: "(248) 852-4300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rochester Hills, approximately 10 miles north of Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rochester Hills, Rochester, Auburn Hills, and northern Oakland County communities.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-4",
      name: "Farmington Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "29335 W 10 Mile Rd",
      city: "Farmington Hills",
      state: "MI",
      zip: "48336",
      phone: "(248) 477-1120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Farmington Hills, approximately 12 miles west of Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Farmington Hills, Novi, and western Oakland County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "troy-5",
      name: "Royal Oak Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W 2nd St",
      city: "Royal Oak",
      state: "MI",
      zip: "48067",
      phone: "(248) 549-0580",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Royal Oak, approximately 10 miles south of Troy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Royal Oak, Madison Heights, Berkley, and southern Oakland County communities.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Oakland County" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Parking & Downtown Hassle", agency: "Yes — downtown Detroit parking fees", fpc: "No — never leave Troy" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Troy corporate professionals and affluent families often discover passport issues right before international departures. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops near Somerset Collection or Big Beaver sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Oakland County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Troy and Birmingham Post Office appointments fill during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
    {
      icon: "ri-time-line",
      title: "Not Checking Passport Validity Before Booking",
      description: "Many countries require 6 months of passport validity beyond your travel dates. Check your passport expiration before booking international flights from DTW.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Oakland County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Big Beaver, Woodward, or Somerset Collection." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Troy address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Troy, MI?", a: "Fast Passport Center offers emergency passport processing in Troy, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (25–30 minutes south via I-75) — without you taking time off work or finding parking in downtown Detroit." },
    { q: "Where is the nearest passport agency to Troy?", a: "The Detroit Passport Agency is the nearest facility to Troy, located at 211 W. Fort St, Suite 1300, Detroit, MI 48226 — approximately 25–30 minutes south via I-75. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can skip the appointment backlog." },
    { q: "Can I get an expedited passport in Birmingham, Rochester Hills, or Bloomfield Hills?", a: "Absolutely. Fast Passport Center serves all of Oakland County including Birmingham, Rochester Hills, Bloomfield Hills, Clawson, Royal Oak, Madison Heights, Berkley, Southfield, Farmington Hills, Novi, Pontiac, Auburn Hills, Waterford, and Rochester. Our courier service works the same way everywhere." },
    { q: "What airports do Troy travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Troy residents — approximately 35–40 minutes south via I-75. DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Gerald R. Ford International (GRR) in Grand Rapids is an alternative for some domestic travel. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Troy, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Troy residents get passport photos taken locally?", a: "Yes. Walgreens, CVS, and Meijer locations throughout Troy, Birmingham, and Rochester Hills offer passport photos. UPS Stores and FedEx Office locations also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve Farmington Hills and Novi?", a: "Yes. Fast Passport Center serves all of Oakland County including Farmington Hills, Novi, and the western suburbs. Our courier service is especially valuable for residents who would otherwise face the commute to downtown Detroit during rush hour." },
    { q: "Can I upgrade my processing speed after I submit?", a: "If you submit through a post office or directly to the government, no — you cannot upgrade speed after submission. With Fast Passport Center, you can upgrade your processing speed at any point before your documents are submitted to the agency. That's a major advantage of our service." },
  ],
  photoLocations: [
    { name: "Meijer — Rochester Road Troy", address: "675 E Big Beaver Rd, Troy, MI 48083", hours: "Mon–Sun: 6AM–Midnight" },
    { name: "Walgreens — Maple Road Troy", address: "2840 W Maple Rd, Troy, MI 48084", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Somerset Collection", address: "2801 W Big Beaver Rd, Troy, MI 48084", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Woodward Birmingham", address: "33302 Woodward Ave, Birmingham, MI 48009", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Troy", address: "1301 E Big Beaver Rd, Troy, MI 48083", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Michigan SOS — Rochester Hills", address: "2860 E Auburn Rd, Rochester Hills, MI 48307", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Rochester Hills, Rochester, Auburn Hills, and northern Oakland County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "35–40 minutes from Troy via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Troy and Oakland County. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "FNT",
      name: "Bishop International Airport (Flint)",
      distance: "Approximately 50 minutes north of Troy via I-75",
      address: "3425 W Bristol Rd, Flint, MI 48507",
      note: "Secondary option for Troy travelers. Direct flights to Orlando, Tampa, Las Vegas, and Chicago.",
      flightUrl: "https://www.bishopairport.org/",
      flightLabel: "FNT Flight Info",
      featured: false,
    },
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport (Grand Rapids)",
      distance: "Approximately 2 hours west of Troy via I-96",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Alternative for Troy travelers seeking additional domestic routes. Direct flights to Atlanta, Chicago, Dallas, and seasonal Caribbean destinations.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Flight Info",
      featured: false,
    },
  ],
};